/**
 * Kapselkomponemnte für Eingabe und Validierung der Prüfortparameter Kalibrierung Abgasmessgerät
 */

import { observer } from 'mobx-react';
import { observable, computed, action } from 'mobx';
import { bind } from '../../../utils/decorators';
import * as React from 'react';
import { InputGroup, FormControl, Table, Panel, FormGroup } from 'react-bootstrap';

interface  IKomponenteBereich {
  min: number | undefined;
  max: number | undefined;
}

class Komponente {
  editable: boolean;
  beschriftung: string;
  einheit: string;
  bezeichner: string;
  formdataprefix: string;

  @observable ist: number | undefined;
  @observable min: number | undefined;
  @observable max: number | undefined;

  constructor (editable: boolean | undefined, beschriftung: string, einheit: string, bezeichner: string, formdataprefix: string, bereich?: IKomponenteBereich) {
    this.editable = editable !== undefined ? editable : true;
    this.beschriftung = beschriftung;
    this.einheit = einheit;
    this.bezeichner = bezeichner;
    this.formdataprefix = formdataprefix;
    this.min = bereich && bereich.min;
    this.max = bereich && bereich.max;
  }

  @bind @action handleIstWertChange(ev: React.FormEvent<FormControl>) {
    this.ist = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : undefined;
  }

  /**
   * Liefert true wenn der Ist-Wert sich im Bereich zwischen min und max befindet (jeweils nur wenn definiert)
   */
  @computed get imToleranzbereich() {
    if ((this.min !== undefined) && (this.ist !== undefined) && (this.ist < this.min)) {
      return false;
    }
    if ((this.max !== undefined) && (this.ist !== undefined) && (this.ist > this.max)) {
      return false;
    }
    return true;
  }

  public render() {
    return (
      <tr key={`tr_${this.bezeichner}`}>
        <td style={{verticalAlign: 'middle'}}>{this.beschriftung}</td>
        <td>
          <InputGroup>
            <FormControl
              type="number"
              readOnly={true}
              name={`${this.formdataprefix}[min]`}
              value={this.min}
              tabIndex={-1}
            />
            <InputGroup.Addon style={{minWidth: '76px'}}>{this.einheit}</InputGroup.Addon>
          </InputGroup>
        </td>
        <td>
          <FormGroup validationState={this.ist === undefined ? 'error' : undefined} style={{margin: '0px'}}>
            <InputGroup>
              <FormControl
                type="number"
                step="any"
                readOnly={!this.editable}
                name={`${this.formdataprefix}[ist]`}
                onChange={this.handleIstWertChange}
                value={this.ist}
                className={this.ist !== undefined && this.imToleranzbereich === true ? 'text-success' : 'text-danger'}
              />
              <InputGroup.Addon style={{minWidth: '76px'}}>{this.einheit}</InputGroup.Addon>
            </InputGroup>
          </FormGroup>
        </td>
        <td>
          <InputGroup>
            <FormControl
              type="text"
              readOnly={true}
              name={`${this.formdataprefix}[max]`}
              value={this.max}
              tabIndex={-1}
            />
            <InputGroup.Addon style={{minWidth: '76px'}}>{this.einheit}</InputGroup.Addon>
            <FormControl
              type="hidden"
              name={`${this.formdataprefix}[toleranzbereich]`}
              value={this.imToleranzbereich ? 'true' : 'false'}
            />
          </InputGroup>
        </td>
      </tr>
    );
  }
}

export interface IAgtPruefortParameterProps {
  titel: string;
  formdataprefix: string;
  bereichLufttemperatur?: IKomponenteBereich;
  bereichLuftfeuchtigkeit?: IKomponenteBereich;
  bereichUmgebungsdruck?: IKomponenteBereich;
  editable?: boolean;
  value?: string;
}

export interface IAgtPruefortParameterState {
  lufttemperatur: Komponente;
  luftfeuchtigkeit: Komponente;
  umgebungsdruck: Komponente;
}

@observer
export default class AgtPruefortParameter extends React.Component<IAgtPruefortParameterProps, IAgtPruefortParameterState> {

  constructor(props: IAgtPruefortParameterProps) {
    super(props);
    this.state = {
      lufttemperatur: new Komponente(props.editable, 'Lufttemperatur', '°C', 'komponente_temperatur', `${this.props.formdataprefix}[temperatur]`, this.props.bereichLufttemperatur),
      luftfeuchtigkeit: new Komponente(props.editable, 'Luftfeuchtigkeit', '%', 'komponente_feuchtigkeit', `${this.props.formdataprefix}[feuchtigkeit]`, this.props.bereichLuftfeuchtigkeit),
      umgebungsdruck: new Komponente(props.editable, 'Umgebungsdruck', 'mbar', 'komponente_druck', `${this.props.formdataprefix}[druck]`, this.props.bereichUmgebungsdruck)
    };
    // Vorhandene Werte übernehmen
    if (props.value) {
      let obj = JSON.parse(props.value);
      this.state.lufttemperatur.ist = obj.temperatur && obj.temperatur.ist;
      this.state.luftfeuchtigkeit.ist = obj.feuchtigkeit && obj.feuchtigkeit.ist;
      this.state.umgebungsdruck.ist = obj.druck && obj.druck.ist;
    }
  }

  public render() {
    return(
      <Panel header={this.props.titel} collapsible={true} defaultExpanded={true}>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="pruefortparameter">
          <thead>
            <tr>
                <th/>
                <th>Min.</th>
                <th>Messwert</th>
                <th>Max.</th>
            </tr>
          </thead>
          <tbody>
            {this.state.lufttemperatur.render()}
            {this.state.luftfeuchtigkeit.render()}
            {this.state.umgebungsdruck.render()}
          </tbody>
        </Table>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/agt/AgtPruefortParameter.tsx